import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';


import Table from '../../components/Table';

const SmsReport = ({closeAllContacts, singleHistory}) => {
  const returnDate = (timestamp) => {
    let res=  "---";
    const ms = typeof timestamp === "string" ? parseInt(timestamp, 10) : timestamp; if(ms && !isNaN(ms)){
      res = new Date(ms).toLocaleString();
    }
    return res;
  };
  return (
    <Dialog
      open
      onClose={closeAllContacts}
    >
      <DialogTitle>Delivery Report</DialogTitle>
      <DialogContent>
        <Table
          column={[
            {name: 'Contact Number', value: 'phoneNumber', cell: (val, row) => val || row.mobile || '--'},
            {name: 'Status', value: 'statusCode', cell: (val, row) => <>{val || row.status || '--'}{row.errorCode ? <span> - {row.errorCode}</span> : ''}</>},
            {name: 'Error', value: 'errorDescription', cell : (val, row) => <div style={{whiteSpace: 'normal',wordWrap: 'break-word'}}>{val || row.errorCode || '--'}</div>},
            {name: 'Sent At', value: 'sentAt', cell: (val) => returnDate(val)},
            {name: 'Delivered/Failed At', value: 'deliveredAt', cell: (val, row) => {
              const delivered = val && val !== '0' ? val : null;
              const failed = row.failedAt && row.failedAt !== '0' ? row.failedAt : null;
              const ts = delivered || failed || row.updatedAt;
              return returnDate(ts);
            }}
          ]}
          serialNumber
          data={singleHistory.list}
          showPagination
          pageOptions={[15]}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={closeAllContacts}>
            Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SmsReport
